import React from "react";
import { Link } from "react-router-dom";
import "./OurServicesMasterCard.scss";
import thumbImg from "resources/images/services-thumbs/brand_strategy.png";

export default function OurServicesMasterCard({
  img = thumbImg,
  title = "Brand Strategy & Identity",
  copy = "...",
  url = "/contact-us",
  label = "Start project",
  serviceUrl = "/brand-strategy-and-identity"
}) {
  return (
    <div className="service-card--master">
      <div
        className="service-thumb"
        style={{ backgroundImage: `url(${img})` }}
      />

      <h6>{title}</h6>
      <p>{copy}</p>

      {/* Buttons row */}
      <div className="service-card__actions">
        <Link to={url} className="btn btn-primary">
          {label}
        </Link>

        <Link to={serviceUrl} className="btn btn-secondary-white">
          Learn more
        </Link>
      </div>
    </div>
  );
}
